var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFwmIicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5569 11.7951C38.432 6.33607 39.9164 3 39.9164 3C39.9164 3 41.6977 7.54918 54.1665 11.7951C66.6354 16.041 69.9011 15.4344 69.9011 15.4344C69.9011 15.4344 70.7916 39.3934 67.229 51.5246C63.6665 63.6557 39.9164 77 39.9164 77C39.9164 77 18.5412 64.5656 13.1974 51.5246C7.8536 38.4836 10.8224 15.4344 10.8224 15.4344C10.8224 15.4344 14.6818 17.2541 26.5569 11.7951Z",
    stroke: "#292929",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25H35V34H25V43H35V54H45V43H54V34H45V25Z",
    fill: "#B31B34",
    stroke: "#292929",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwmIicon);
export default __webpack_public_path__ + "static/media/FWMI icon.4a7c91c3e881528be790552a5c457171.svg";
export { ForwardRef as ReactComponent };